import { render } from "./ImportDetailSettingsTab.vue?vue&type=template&id=1370e6d0&scoped=true"
import script from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js"
export * from "./ImportDetailSettingsTab.vue?vue&type=script&lang=js"

import "./ImportDetailSettingsTab.vue?vue&type=style&index=0&id=1370e6d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1370e6d0"]])

export default __exports__